import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";

export default function useCandidateDetails(candidateId, isUuid = false) {
  const axios = useAxios();
  const client = useQueryClient();
  const key = isUuid ? "uuid" : "id";

  const { data, error, isLoading } = useQuery({
    queryKey: ["candidateDetails", candidateId],
    queryFn: () => {
      return axios.get("/candidate", {
        params: {
          [key]: candidateId,
        },
      });
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!candidateId,
  });

  handleError(error);

  const candidate = data?.data;

  const invalidate = () => {
    client.invalidateQueries({ queryKey: ["candidateDetails", candidateId] });
  };

  return { candidate, isLoading, invalidate };
}
